export interface CompanyProjectMetrics {
  claManagersCount: string;
  companyId: string;
  companyName: string;
  contributorsCount: string;
  projectId: string;
  projectName: string;
  projectLogoUrl?: string;
}
